import { AddButton } from '@/components';
import { PathTemplateTaskDto, PathTemplateTaskGroupDto } from '@/core';
import {
  ImportTasksModalInitialValue,
  SelectTaskTemplateFormValue,
  SelectTaskTemplateModal,
} from '@/views';
import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ImportPathTemplateTasksModal } from './ImportPathTemplateTasksModal';

interface ImportTasksButtonProps {
  className?: string;
  onImport: (formValue: {
    groups: PathTemplateTaskGroupDto[];
    tasks: PathTemplateTaskDto[];
  }) => void;
  communityId: string | undefined;
}

export function ImportPathTemplateTasksButton(props: ImportTasksButtonProps) {
  const { className, onImport, communityId } = props;
  const { t } = useTranslation();

  const [isTemplateModalOpen, setTemplateModalOpen] = useState(false);
  const [isImportModalOpen, setImportModalOpen] = useState(false);
  const [importModalInitialValue, setImportModalInitialValue] =
    useState<ImportTasksModalInitialValue>();

  const handleTemplateSubmit = useCallback(
    (formValue: SelectTaskTemplateFormValue) => {
      setImportModalInitialValue({ templateIds: formValue.templateIds });
      setTemplateModalOpen(false);
      setImportModalOpen(true);
    },
    [],
  );

  const openTemplateSelection = () => setTemplateModalOpen(true);
  const closeTemplateModal = () => setTemplateModalOpen(false);
  const closeImportModal = () => setImportModalOpen(false);

  return (
    <div className={className}>
      <AddButton onClick={openTemplateSelection} ghost>
        {t('tasks.details.importButton')}
      </AddButton>

      {isTemplateModalOpen && (
        <SelectTaskTemplateModal
          title={t('tasks.details.importTitle')}
          onClose={closeTemplateModal}
          onSubmit={handleTemplateSubmit}
          allTypes={true}
          communityId={communityId}
        />
      )}

      {isImportModalOpen && (
        <ImportPathTemplateTasksModal
          title={t('tasks.details.importTitle')}
          onClose={closeImportModal}
          onSubmit={onImport}
          value={importModalInitialValue}
          communityId={communityId}
        />
      )}
    </div>
  );
}
